import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Stopa } from './stopa';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-stopa-modal-update',
  templateUrl: './stopa-modal-update.component.html'
})
export class StopaModalUpdateComponent extends BaseModalUpdateComponent<Stopa> implements OnInit {

  
  constructor(
    protected modalContainerService: ModalContainerService<Stopa>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }


  ngOnInit() {
  }

}
